export const UPDATE_PROFILE_IMAGE = 'UPDATE_PROFILE_IMAGE';

export const updateProfileImage = (image) => ({
  type: UPDATE_PROFILE_IMAGE,
  payload: { image }
});
